import React from "react";

import CommonSelect from "../../../CommonComponents/Select/CommonSelect";

import { buildSelectStylesBundle } from "../AddVendorModal.styles";

const defaultSelectStyles = buildSelectStylesBundle();

const VendorSelectField = ({
  field,
  value,
  error,
  onChange,
  onStateChange,
}) => {
  const commonProps = {
    id: field.name,
    name: field.name,
    label: field.label,
    value,
    options: field.options,
    placeholder: field.placeholder,
    disabled: field.disabled,
    required: true,
    error,
    styles: defaultSelectStyles,
  };

  if (field.name === "state") {
    return <CommonSelect {...commonProps} onChange={onStateChange} />;
  }

  return <CommonSelect {...commonProps} onChange={onChange} />;
};

export default VendorSelectField;
